import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import BankTransferDetailViewModel from "../../../../viewModels/finance/bankExports/bankTransfers/bankTransferDetailViewModel";
import { registerView } from "@frui.ts/views/dist";
import BankExportDetailView from "../bankExportDetailView";

const BankTransferDetailView: ViewComponent<BankTransferDetailViewModel> = observer(({ vm }) => {
  return <BankExportDetailView vm={vm} />;
});

registerView(BankTransferDetailView, BankTransferDetailViewModel);
